import axios from "axios";

const CONTROLLER_PATH = "Customer";

class CustomerService {
    //CREATE
    customerimport(formData) {
        //formData.append('_method', 'PUT');
        return axios
            .post(CONTROLLER_PATH + "/customerimport", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => response.data);
    }


    create(formData) {
        return axios
            .post(CONTROLLER_PATH, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => response.data);
    }

    sendcustomersms(parameters) {
        return axios.post(CONTROLLER_PATH + "/sendcustomersms", parameters).then((response) => {
            return response.data;
        });
    }

    sendcustomercardsms(customerId, companyId) {
        var urlParameters = {};
        if (customerId)
            urlParameters.customerId = customerId;
        if (companyId)
            urlParameters.companyId = companyId;
        console.log(urlParameters);
        return axios.post(CONTROLLER_PATH + "/sendcustomercardsms", null, {params: urlParameters}).then((response) => {
            return response.data;
        });
    }

    addNote(customerId, text) {
        return axios.put(CONTROLLER_PATH + "/" + customerId + "/addNote", {text: text}).then((response) => response.data);
    }

    sendconsentsms(customerId) {
        return axios.post(CONTROLLER_PATH + "/SendConsentSms/" + customerId).then(() => {
        });
    }

    sendwelcomesmsesforcompanycustomers(urlParameters) {
        return axios.get(CONTROLLER_PATH + "/sendwelcomesmsesforcompanycustomers/", {params: urlParameters}).then(() => {
        });
    }

    sendconsentsmsesforcompanycustomers(urlParameters) {
        return axios.get(CONTROLLER_PATH + "/sendconsentsmsesforcompanycustomers/", {params: urlParameters}).then(() => {
        });
    }

    sendcardsmsesforcompanycustomers(urlParameters) {
        return axios.get(CONTROLLER_PATH + "/sendcardsmsesforcompanycustomers/", {params: urlParameters}).then(() => {
        });
    }

    downloadmedicallegalconsentdocument(urlParameters) {
        return axios.get(CONTROLLER_PATH + "/downloadmedicallegalconsentdocument/", {
            params: urlParameters,
            responseType: 'blob'
        });
    }

    //READ
    get(id, urlParameters, requestId) {
        return axios
            .get(CONTROLLER_PATH + (id ? "/" + id : ""), {
                params: urlParameters,
                requestId: requestId,
            })
            .then((response) => ({
                data: response.data,
                requestId: response.config.requestId,
            }));
    }

    getCustomerStatusesCompany() {
        return axios.get(CONTROLLER_PATH + "/getCustomerStatusesCompany").then((response) => response.data);
    }

    getCustomerStatusesIndividual() {
        return axios.get(CONTROLLER_PATH + "/getCustomerStatusesIndividual").then((response) => response.data);
    }

    getDebitOrderDates() {
        return axios.get(CONTROLLER_PATH + "/getDebitOrderDates").then((response) => ({
            data: response.data,
        }));
    }

    getConsentSmsStatuses() {
        return axios.get(CONTROLLER_PATH + "/getConsentSmsStatuses").then((response) => ({
            data: response.data,
        }));
    }

    comissionReport(fromDate, toDate) {
        var urlParameters = {
            fromDate: fromDate,
            toDate: toDate,
        };
        return axios
            .get(CONTROLLER_PATH + "/ComissionReport", {
                params: urlParameters,
            })
            .then((response) => {
                return response.data;
            });
    }

    customerLogReport(urlParameters) {
        return axios.get(CONTROLLER_PATH + "/CustomerLogReport", {params: urlParameters}).then((response) => {
            return response.data;
        });
    }

    getAccisureDashboard() {
        return axios.get(CONTROLLER_PATH + "/GetAccisureDashboard").then((response) => response.data);
    }

    sendwelcomeEmail(id) {
        return axios.get(CONTROLLER_PATH + "/SendWelcomeEmail/" + id).then(() => {
        });
    }

    sendwelcomeSms(id) {
        return axios.post(CONTROLLER_PATH + "/SendWelcomeSms/" + id).then(() => {
        });
    }

    getbankaccounttypes() {
        return axios.get(CONTROLLER_PATH + "/GetBankAccountTypes").then((response) => response.data);
    }

    //UPDATE
    update(id, formData) {
        //formData.append('_method', 'PUT');
        return axios
            .put(CONTROLLER_PATH + "/" + id, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => response.data);
    }

    addDependant(customerId, dependantIdentityId) {
        return axios.post(CONTROLLER_PATH + "/" + customerId + "/AddDependant/" + dependantIdentityId).then((response) => response.data);
    }

    removeDependant(customerId, dependantIdentityId) {
        return axios.post(CONTROLLER_PATH + "/" + customerId + "/RemoveDependant/" + dependantIdentityId).then((response) => response.data);
    }

    //DELETE
    delete(id) {
        return axios.delete(CONTROLLER_PATH + "/" + id).then(() => {
        });
    }
}

export default new CustomerService();
